package devxertech.com.pages.career.devxerCareer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.alignItems
import com.varabyte.kobweb.compose.css.cursor
import com.varabyte.kobweb.compose.css.fontWeight
import com.varabyte.kobweb.compose.css.zIndex
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.contactSection.Country
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexShrink
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.maxHeight
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.outline
import org.jetbrains.compose.web.css.overflowX
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input

@Composable
fun UnderlinedPhoneInputWithFlagCountry(
    countries: List<Country>,
    selectedCountry: Country?,
    onCountryChange: (Country) -> Unit,
    phone: String,
    onPhoneChange: (String) -> Unit,
    onError: (String?) -> Unit,
    placeholder: String = "",
    placeholderModifier: Modifier = Modifier,
) {
    val sitePalette = ColorMode.current.toSitePalette()

    var dropdownOpen by remember { mutableStateOf(false) }
    var search by remember { mutableStateOf("") }

    // filtered list
    val filteredCountries = remember(countries, search) {
        if (search.isBlank()) countries
        else countries.filter {
            it.name.contains(search, ignoreCase = true) ||
                    it.iso.contains(search, ignoreCase = true) ||
                    it.dialCode.contains(search)
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Relative)
    ) {
        // 🔹 Row container
        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    height(40.px)
                }
            }
        ) {

            // LEFT: Custom dropdown (Flag + dialCode)
            Box(
                modifier = Modifier
                    .position(Position.Relative)
            ) {
                // Trigger button (same look as Select)
                Div(
                    attrs = {
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            cursor(Cursor.Pointer)

                            backgroundColor(Color.transparent)
                            color(Color.white)
                            fontSize(16.px)
                            fontWeight(FontWeight.Normal)
                            fontFamily(Constants.FONT_FAMILY)
                            paddingRight(8.px)
                            width(110.px)
                            minWidth(120.px)
                            maxWidth(110.px)
                            flexShrink(0)
                            overflowX("auto")
                            property("text-overflow", "ellipsis")
                            property("white-space", "nowrap")

                            border(0.px)
                            property("user-select", "none")
                        }
                        onClick { dropdownOpen = !dropdownOpen }
                    }
                ) {

                    if (selectedCountry != null) {
                        Img(
                            src = selectedCountry.flagUrl,
                            attrs = {
                                attr("alt", "")
                                style {
                                    width(18.px)
                                    height(14.px)
                                    marginRight(4.px)
                                    borderRadius(2.px)
                                    property("object-fit", "cover")
                                }
                            }
                        )
                        SpanText(
                            text = " ${selectedCountry.dialCode}",
                            modifier = Modifier.color(Color.white).fontSize(14.px)
                        )

                    } else {
                        SpanText(
                            text = "+92 PK",
                            modifier = Modifier.color(Color.white).fontSize(16.px)
                        )
                    }

                    SpanText(
                        text = " ▼",
                        modifier = Modifier
                            .fontSize(12.px)
                            .color(Color.white) // keep white
                            .margin(left = 2.px)
                            .styleModifier {
                                property("display", "inline-flex")
                                property("white-space", "nowrap !important")
                            }
                    )
                    Div(
                        attrs = {
                            style {
                                width(2.px)
                                height(20.px)
                                backgroundColor(Color.white)
                                margin(8.px)
                                opacity(1)
                                flexShrink(0)
                            }
                        }
                    )
                }

                // Dropdown
                if (dropdownOpen) {
                    Div(
                        attrs = {
                            style {
                                position(Position.Absolute)
                                top(42.px)
                                left(0.px)
                                zIndex(999)
                                width(280.px)
                                maxHeight(280.px)
                                overflowY("auto")
                                backgroundColor(Color.white)
                                borderRadius(8.px)
                                border(1.px, LineStyle.Solid, sitePalette.contactText.rgb)
                                padding(8.px)
                            }
                        }
                    ) {

                        // Search bar (optional) - uses your colors lightly
                        Input(InputType.Text) {
                            value(search)
                            onInput { search = it.value }

                            style {
                                width(100.percent)
                                height(34.px)
                                paddingLeft(10.px)
                                paddingRight(10.px)
                                fontSize(14.px)
                                fontFamily(Constants.FONT_FAMILY)
                                borderRadius(6.px)
                                border(1.px, LineStyle.Solid, sitePalette.contactText.rgb)
                                outline("none")
                                marginBottom(8.px)
                            }

                            placeholder("Search country...")
                        }

                        filteredCountries.forEach { country ->
                            Div(
                                attrs = {
                                    style {
                                        display(DisplayStyle.Flex)
                                        alignItems(AlignItems.Center)
                                        padding(8.px)
                                        borderRadius(6.px)
                                        cursor(Cursor.Pointer)
                                        color(sitePalette.contactText.rgb)
                                        fontFamily(Constants.FONT_FAMILY)
                                        fontSize(14.px)
                                    }

                                    onClick {
                                        onCountryChange(country)
                                        dropdownOpen = false
                                        search = ""
                                    }

                                    onMouseOver {
                                        it.currentTarget?.unsafeCast<org.w3c.dom.HTMLElement>()
                                            ?.style?.backgroundColor = "rgba(0,0,0,0.05)"
                                    }
                                    onMouseOut {
                                        it.currentTarget?.unsafeCast<org.w3c.dom.HTMLElement>()
                                            ?.style?.backgroundColor = "transparent"
                                    }
                                }
                            ) {
                                Img(
                                    src = country.flagUrl,
                                    attrs = {
                                        attr("alt", "")
                                        style {
                                            width(20.px)
                                            height(14.px)
                                            marginRight(10.px)
                                            borderRadius(2.px)
                                            property("object-fit", "cover")
                                        }
                                    }
                                )

                                SpanText(
                                    text = country.dialCode,
                                    modifier = Modifier.fontSize(14.px)
                                        .fontWeight(FontWeight.Medium)
                                )

                                SpanText(
                                    text = "  ${country.iso} • ${country.name}",
                                    modifier = Modifier.fontSize(13.px).margin(left = 8.px)
                                )
                            }
                        }
                    }
                }
            }

            // RIGHT: Phone input (your original)
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .position(Position.Relative)
                    .margin(left = 5.px)
            ) {
                Input(InputType.Text) {
                    value(phone)
                    onInput {
                        val digitsOnly = it.value.filter { ch -> ch.isDigit() }

                        when {
                            digitsOnly.length > 14 -> return@onInput
                            digitsOnly.length in 7..14 -> {
                                onError(null)
                                onPhoneChange(digitsOnly)
                            }

                            else -> {
                                onError("Contact number must be 7 to 14 digits")
                                onPhoneChange(digitsOnly)
                            }
                        }
                    }

                    style {
                        width(90.percent)
                        border(0.px)
                        outline("none")
                        backgroundColor(Color.transparent)
                        fontSize(18.px)
                        color(Color.white)
                        fontFamily(Constants.FONT_FAMILY)
                    }
                }

                if (phone.isEmpty()) {
                    SpanText(
                        text = placeholder,
                        modifier = placeholderModifier
                            .position(Position.Absolute)
                            .top(0.px)
                            .left(0.px)
                            .fontSize(18.px)
                            .lineHeight(28.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .color(Color.white)
                            .pointerEvents(PointerEvents.None)
                            .flexShrink(0)
                    )
                }
            }
        }

        // 🔹 Underline (default)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Color.white)
                .transition(Transition.of(TransitionProperty.All, 300.ms))
                .position(Position.Absolute)
                .bottom(0.px)
        )

        // 🔹 Underline highlight (only when phone not empty)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Color.darkblue)
                .transition(Transition.of(TransitionProperty.All, 300.ms))
                .position(Position.Absolute)
                .bottom(0.px)
                .scale(if (phone.isNotEmpty()) 1.0 else 0.0, 1.0)
        )
    }
}
